export function isImageMimeType(file: File): boolean {
    return file.type.startsWith('image/');
}

export function isWithinMaxImageSize(file: File, maxSizeMb: number): boolean {
    return file.size / 1000000 <= maxSizeMb;
}

export function getFileSizeFormatted(size: number): string {
    const kb = size / 1024;
    if (kb < 1024) {
        return `${Math.round(kb)} KB`;
    } else {
        const mb = kb / 1024;
        return `${mb.toFixed(1)} MB`;
    }
}

/**
 * A helper for downloading files.
 *
 * @param data
 * @param filename
 */
export function saveAs(data: BlobPart, filename: string) {
    const url = window.URL.createObjectURL(new Blob([data]));

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
